import { Loader } from "components";
import { MatchingComonProfil } from 'components/ComonProfil';
import { injectIntl } from "react-intl";
import { MatchingActioner } from "services/matching";
import { StudentActioner } from "services/student";
import { TimelineActioner } from "services/timeline";

function StudentAllTimelineComponent(props) {
  const { id } = props;

  function renderPage(matchs, timelines) {
    return <MatchingComonProfil matchs={matchs} timelines={timelines} displayCampaign={true} />;
  }

  function render(render){
    StudentActioner.get(id).then((student) => {
        Promise.all([MatchingActioner.getStudentMatchingByUuid(student.uuid), TimelineActioner.getStudentTimelineByUuid(student.uuid)]).then(
          ([matchs, timelines]) => {
            render(renderPage(matchs, timelines));
          }
        );
    });
  }


  return <Loader render={render} />;
}

const StudentAllTimeline = injectIntl(StudentAllTimelineComponent);

export { StudentAllTimeline };
